export const LOG_CONSTS = {
    GET_LOGS: "GET_LOGS",
};
